import React, { useState } from "react";
import { useQuery } from "react-query";
import { toast } from "react-toastify";

const AllUsers = () => {
  const [displayAdmin, setDisplayAdmin] = useState(null);
  const { data: users = [], refetch } = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const res = await fetch(
        "https://bike-resell-server-hasanalibd.vercel.app/users"
      );
      const data = await res.json();
      return data;
    },
  });

  //
  const handleDelete = (user) => {
    const agree = window.confirm(
      `Are you sure you want to delete: ${user.name}`
    );
    if (agree) {
      // console.log('deleting user with id:', user._id);
      fetch(
        `https://bike-resell-server-hasanalibd.vercel.app/users/${user._id}`,
        {
          method: "DELETE",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.deletedCount > 0) {
            const remaingingList = displayAdmin.filter(
              (usr) => usr._id !== user._id
            );
            setDisplayAdmin(remaingingList);
            refetch();
            toast.warning("Deleted Successfully");
          }
        });
    }
  };

  return (
    <div className="mt-10 mx-10">
      <h1 className="text-3xl font-semibold my-6">User List: {users.length}</h1>
      <div className="overflow-x-auto">
        <table className="table w-full">
          <thead>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Email</th>
              <th>Admin</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, i) => (
              <tr key={user._id}>
                <th>{1 + i}</th>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>
                  {user.role !== "Admin" ? (
                    <button
                      onClick={() => {
                        fetch(
                          `https://bike-resell-server-hasanalibd.vercel.app/users/admin/${user.email}`,
                          {
                            method: "put",
                            headers: {
                              "content-type": "application/json",
                            },
                            body: JSON.stringify({
                              name: user.name,
                              email: user.email,
                              role: "Admin",
                            }),
                          }
                        ).then((res) => {
                          refetch();
                        });
                      }}
                      className="btn btn-xs btn-info"
                    >
                      Verify
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        fetch(
                          `https://bike-resell-server-hasanalibd.vercel.app/users/admin/${user.email}`,
                          {
                            method: "put",
                            headers: {
                              "content-type": "application/json",
                            },
                            body: JSON.stringify({
                              name: user.name,
                              email: user.email,
                              role: "Am Public",
                            }),
                          }
                        ).then((res) => {
                          refetch();
                        });
                      }}
                      className="btn btn-xs btn-secondary"
                    >
                      Admin
                    </button>
                  )}
                </td>
                <td>
                  <button
                    onClick={() => handleDelete(user)}
                    className="btn btn-circle btn-error btn-sm"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllUsers;
